import React, {Component} from 'react';
import DocumentTitle from 'react-document-title';
import {Link} from 'react-router-dom'
import marked from 'marked';

import Input from '../../components/Input';
import SelectCheck from '../../components/SelectCheck';
import MarkdownRenderer from '../../components/MarkdownRenderer';

class Forms extends Component {

    constructor(props) {
        super(props);

        this.state = {
            inputText: '',
            inputPassword: '',
            inputSearch: '',
            inputDisabled: '',
            inputLoading: '',
            inputError: '',
            inputSuccess: '',
            inputEdit: '',
            typeText: '',
            typePassword: '',
            typeSearch: '',
            disabled: '',
            loading: '',
            error: '',
            success: '',
            textarea: '',
            select: '',
            selectMany: '',
            checkbox: '',
            radio: '',
            editGroup: '',
            contextualMessages: ''
        }

        this.props.includeNav();
    }

    componentWillMount() {
        this.fetchMarkdown('typeText');
        this.fetchMarkdown('typePassword');
        this.fetchMarkdown('typeSearch');
        this.fetchMarkdown('typeSearch');
        this.fetchMarkdown('disabled');
        this.fetchMarkdown('loading');
        this.fetchMarkdown('error');
        this.fetchMarkdown('success');
        this.fetchMarkdown('textarea');
        this.fetchMarkdown('select');
        this.fetchMarkdown('selectMany');
        this.fetchMarkdown('checkbox');
        this.fetchMarkdown('radio');
        this.fetchMarkdown('editGroup');
        this.fetchMarkdown('contextualMessages');
    }

    fetchMarkdown = (file) => {
        const path = require(`./${file}.md`);
        fetch(path)
        .then(response => {
            return response.text()
        })
        .then(text => {
            this.setState({
                [file]: marked(text)
            })
        })
    }

    handleChange = (event) => {
        this.setState({[event.target.id]: event.target.value});
    }

    selectCheckCallback = (options) => {
        console.log('OPTIONS: ', options)
    }

    render() {

        const selectCheckOptions = [
            {
                value: "opt1",
                label: "Option1"
            },{
                value: "opt2",
                label: "Option2"
            },{
                value: "opt3",
                label: "Option3"
            }
        ]

        return (
            <DocumentTitle
                title={'BCS Documentation - Forms'}>
                <section className="page" data-component="forms">
                    <div className="row">
                        <div className="col-xs-12 col-gutter-lr border-bottom">
                            <h1>Forms</h1>
                            <p>Form elements and controls can easily be added with pure HTML and without any additional styling. Just be sure to follow <Link to="/accessibility">accessibility standards</Link> for form markup.</p>
                        </div>
                        <div className="col-xs-12 col-gutter-lr">
                            <h2>Inputs</h2>
                        </div>
                        <div className="col-xs-12 col-md-6 col-gutter-lr">
                            <Input
                                label="Text Input"
                                type="text"
                                id="inputText"
                                value={this.state.inputText}
                                onChange={this.handleChange}
                                placeholder="Input text"
                            />
                        </div>
                        <div className="col-xs-12 col-gutter-lr">
                            <MarkdownRenderer text={this.state.typeText}/>
                        </div>
                        <div className="col-xs-12 col-md-6 col-gutter-lr">
                            <Input
                                label="Password Input"
                                type="password"
                                id="inputPassword"
                                value={this.state.inputPassword}
                                onChange={this.handleChange}
                                placeholder="Input password"
                            />
                        </div>
                        <div className="col-xs-12 col-gutter-lr">
                            <MarkdownRenderer text={this.state.typePassword}/>
                        </div>
                        <div className="col-xs-12 col-md-6 col-gutter-lr">
                            <Input
                                label="Search Input"
                                type="search"
                                id="inputSearch"
                                value={this.state.inputSearch}
                                onChange={this.handleChange}
                                placeholder="Search..."
                            />
                        </div>
                        <div className="col-xs-12 col-gutter-lr">
                            <MarkdownRenderer text={this.state.typeSearch}/>
                        </div>
                        <div className="col-xs-12 col-md-6 col-gutter-lr">
                            <Input
                                label="Input Disabled"
                                type="text"
                                id="inputDisabled"
                                value={this.state.inputDisabled}
                                onChange={this.handleChange}
                                placeholder="Input Disabled"
                                disabled={true}
                            />
                        </div>
                        <div className="col-xs-12 col-gutter-lr">
                            <MarkdownRenderer text={this.state.disabled}/>
                        </div>
                        <div className="col-xs-12 col-md-6 col-gutter-lr">
                            <Input
                                label="Input Loading"
                                type="text"
                                id="inputLoading"
                                value={this.state.inputLoading}
                                onChange={this.handleChange}
                                placeholder="Input Loading"
                                loading={true}
                            />
                        </div>
                        <div className="col-xs-12 col-gutter-lr">
                            <MarkdownRenderer text={this.state.loading}/>
                        </div>
                        <div className="col-xs-12 col-md-6 col-gutter-lr">
                            <Input
                                label="Error on input"
                                type="text"
                                id="inputError"
                                value={this.state.inputError}
                                onChange={this.handleChange}
                                placeholder="Input Error"
                                error={true}
                            />
                        </div>
                        <div className="col-xs-12 col-gutter-lr">
                            <MarkdownRenderer text={this.state.error}/>
                        </div>
                        <div className="col-xs-12 col-md-6 col-gutter-lr">
                            <Input
                                label="Successful input"
                                type="text"
                                id="inputSuccess"
                                value={this.state.inputSuccess}
                                onChange={this.handleChange}
                                placeholder="Input Success"
                                success={true}
                            />
                            </div>
                        <div className="col-xs-12 col-gutter-lr">
                            <MarkdownRenderer text={this.state.success}/>
                        </div>
                        <div className="col-xs-12 col-md-6 col-gutter-lr">
                            <h2>Textareas</h2>
                            <label htmlFor="textarea">Textarea</label>
                            <textarea name="textarea" id="textarea" rows="8" cols="80" placeholder="Text Area" ></textarea>
                        </div>
                        <div className="col-xs-12 col-gutter-lr">
                            <MarkdownRenderer text={this.state.textarea}/>
                        </div>
                        <div className="col-xs-12 col-md-6 col-gutter-lr">
                            <h2>Select</h2>
                            <label htmlFor="select-one">Select One</label>
                            <select name="select-one" id="select-one">
                                <option value="">Option 1</option>
                                <option value="">Option 2</option>
                                <option value="">Option 3</option>
                            </select>
                        </div>
                        <div className="col-xs-12 col-gutter-lr">
                            <MarkdownRenderer text={this.state.select}/>
                        </div>
                        <div className="col-xs-12 col-md-6 col-gutter-lr">
                            <h2>Select Many</h2>
                            <SelectCheck
                                title="Select Many"
                                options={selectCheckOptions}
                                onChange={this.selectCheckCallback}
                            />
                        </div>
                        <div className="col-xs-12 col-gutter-lr">
                            <MarkdownRenderer text={this.state.selectMany}/>
                        </div>
                        <div className="col-xs-12 col-md-6 col-gutter-lr">
                            <h2>Checkboxes</h2>
                            <fieldset>
                                <label htmlFor="check-one" className="label-active">
                                    <input type="checkbox" id="check-one" name="check-one" value=""/>
                                    Check One
                                </label>
                                <label htmlFor="check-two" className="label-active">
                                    <input type="checkbox" id="check-two" name="check-two" value=""/>
                                    Check Two
                                </label>
                            </fieldset>
                        </div>
                        <div className="col-xs-12 col-gutter-lr">
                            <MarkdownRenderer text={this.state.checkbox}/>
                        </div>
                        <div className="col-xs-12 col-md-6 col-gutter-lr">
                            <h2>Radios</h2>
                            <label htmlFor="radio-one" className="label-active margin-r-3">
                                <input type="radio" name="radio-group" id="radio-one" value=""/>
                                Radio One
                            </label>
                            <label htmlFor="radio-two" className="label-active">
                                <input type="radio" name="radio-group" id="radio-two" value=""/>
                                Radio Two
                            </label>
                        </div>
                            <div className="col-xs-12 col-gutter-lr">
                                <MarkdownRenderer text={this.state.radio}/>
                            </div>
                        <div className="col-xs-12">
                            <h2>Edit Group</h2>
                            <div className="padding-3 bg-secondary margin-t-6 margin-b-6">
                                <Input
                                    label="Edit Input"
                                    type="text"
                                    id="inputEdit"
                                    value={this.state.inputEdit}
                                    onChange={this.handleChange}
                                    placeholder="Edit input"
                                />
                                <label htmlFor="radio-one-edit" className="label-active margin-r-3">
                                    <input type="radio" name="radio-group" id="radio-one-edit" value=""/>
                                    Radio One
                                </label>
                                <label htmlFor="radio-two-edit" className="label-active">
                                    <input type="radio" name="radio-group" id="radio-two-edit" value=""/>
                                    Radio Two
                                </label>
                                <button className="btn-small btn-save">Save</button>
                                <button className="btn-small btn-delete btn-tertiary">Cancel</button>
                            </div>
                            <MarkdownRenderer text={this.state.editGroup}/>
                            <hr/>
                            <h2>Contextual Messages</h2>
                            <p className="context-info">Email address input is case sensitive.</p>
                            <p className="context-error">There doesn’t seem to be an account associated with the email: <strong>your@email.com</strong>.</p>
                            <p className="context-success">Success! We’ve sent instructions on resetting your password to <strong>your@email.com</strong>.</p>
                            <p className="context-warn">Warning. You have attempted this action too many times.</p>
                            <MarkdownRenderer text={this.state.contextualMessages}/>
                        </div>
                    </div>
                </section>
            </DocumentTitle>
        )
    }
}

export default Forms;



// WEBPACK FOOTER //
// ./src/pages/Forms/index.js